import React from 'react';
import { State } from 'react-router';
import api from 'rawr/api';
import log from 'rawr/utils/log';
import Button from 'rawr/layout/Button';
import notify from 'rawr/notify';
import Columns from 'rawr/layout/Columns';
import isPreAPOrSpringboardSlug from 'utils/slug';

import './Contact.scss';
import Loading from './LoadingSpinner';
import cn from 'classnames'
import btn from 'rawr/layout/btn';

// TODO: Move constants to environment variable
// Note: Any change made to these constants should also be updated in the backend @ core/server/mail/contact.py
const MAX_INDIVIDUAL_FILE_SIZE = 10 * 1024 * 1024;
const MAX_BULK_FILE_SIZE = 15 * 1024 * 1024;

const SESSION_STORAGE_CONTACT_US_KEY = 'contactUsData';


export default React.createClass({
    mixins: [State],
    propTypes: {
        extraData: React.PropTypes.func,
        closePopover: React.PropTypes.func,
    },
    getDefaultProps() {
        return {
            closePopover: function () { },
        };
    },
    componentDidMount() {
        this.retrieveFromSessionStorage(SESSION_STORAGE_CONTACT_US_KEY);
    },
    getInitialState() {
        return {
            email: this.props.user.email,
            message: '',
            issueType: '',
            issueDescriptionType: '',
            deviceType: '',
            deviceDetail: '',
            isInstitutionalDevice: '',
            subject: '',
            isSendButtonDisabled: false,
            files: [],
            loading: false
        }
    },
    isSendButtonDisabled() {
        const {
            isSendButtonDisabled,
            message,
            issueType,
            issueDescriptionType,
            deviceType,
            deviceDetail,
            isInstitutionalDevice,
            email
        } = this.state;

        let checks = [
            isSendButtonDisabled,
            issueType === '' || (issueType === 'issueDescription' && issueDescriptionType === ''),
            message === '',
            !this.props.user.email && email === ''
        ];

        if (this.requireMoreDetails()) {
            checks = checks.concat(
                [
                    deviceType === '',
                    deviceDetail === '',
                    isInstitutionalDevice === '',
                ]
            )
        }

        return checks.reduce((r, v) => r + v);
    },
    setStateByKey(e) {
        let data = {
            ..._.omit(this.state, e.target.name),
            [e.target.name]: e.target.value
        }

        this.setState(data);
        this.saveToSessionStorage(SESSION_STORAGE_CONTACT_US_KEY, data);
    },
    requireMoreDetails() {
        return this.state.issueType === "issueDescription" || this.state.issueType === "loggingIn";
    },
    saveToSessionStorage(key, data) {
        if (!data) return;

        let promises = [];
        let fileData = [];

        data.files.forEach(element => {
            fileData.push({ name: element.name, type: element.type });
            promises.push(this.getFileBase64String(element));
        });

        Promise.all(promises)
            .then(allData => {
                data.files = allData.map((fileString, index) => Object.assign(fileData[index], { base64String: fileString }));
                sessionStorage.setItem(key, JSON.stringify(data));
            })

        sessionStorage.setItem(key, JSON.stringify(data));
    },
    retrieveFromSessionStorage(key) {
        let data = JSON.parse(sessionStorage.getItem(key));

        if (!data) return;

        let promises = [];

        data.files.forEach(element => promises.push(this.getFilefromBase64String(element.base64String, element.name, element.type)));

        Promise.all(promises)
            .then(allData => {
                data.files = allData;
                this.setState(data);
            })

        this.setState(data);
    },
    clearDataFromSessionStorage(key) {
        sessionStorage.removeItem(key);
    },
    getFileBase64String(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
            reader.readAsDataURL(file);
        });
    },
    getFilefromBase64String(fileString, filename, fileType) {
        return fetch(fileString)
            .then(res => res.blob())
            .then(blob => new File([blob], filename, { type: fileType }))
    },
    shouldDisplayPLContactOption() {
        let shouldDisplayOption = false;
        if (!current_user.anonymous) {
            shouldDisplayOption = true;
            const params = this.getParams();
            let course = params && (params.course || params.slug);

            // exclude any AP-only users (non-Springboard)
            if (current_user.programs === 'AP' && current_user.email.indexOf(':') == -1) {
                shouldDisplayOption = false;
            }

            // when user is inside course decide based on slug
            if (course) {
                if (isPreAPOrSpringboardSlug(course)) {
                    shouldDisplayOption = true;
                } else {
                    shouldDisplayOption = false;
                }
            }
        }
        return shouldDisplayOption;
    },
    sendMessage() {
        this.setState({ isSendButtonDisabled: true });
        const user = this.props.user || {};
        const {
            subject,
            message,
            issueDescriptionType,
            issueType,
            deviceType,
            deviceDetail,
            isInstitutionalDevice,
            files
        } = this.state;

        const body = {
            message: message,
            email: user.email || this.state.email,
            first_name: user.first_name,
            last_name: user.last_name,
            user_id: user.id,
            browser: navigator.userAgent,
            deviceType,
            deviceDetail,
            isInstitutionalDevice,
            url: location.href,
            logs: log.getCollected(),
            subject: (issueDescriptionType || issueType) + (subject ? ' - ' + subject : '')
        };

        if (this.props.extraData) {
            _.assign(body, this.props.extraData());
        }

        let contactUrl = config.contact_post_url;
        if (issueType === 'pl') {
            let splitUrlArray = config.contact_post_url.split('/');
            splitUrlArray.pop();
            contactUrl = splitUrlArray.join('/') + '/pl';
        }

        if (files.length > 0) {
            return this.submitRequestWithFiles(contactUrl, body, files)
        }

        this.setState({ loading: true })

        return api.post(contactUrl, {
            body
        }).then(
            () => {
                this.setState({ loading: false })
                notify("Your message has been sent!", { timeout: 5 });
                this.clearDataFromSessionStorage(SESSION_STORAGE_CONTACT_US_KEY);
                /** Set HelpMenus state value popover.close to true, this will update the PopOver component close prop to true */
                this.props.closePopover(true);
            },
            () => {
                this.setState({ loading: false })
                notify.error("Error while sending mail, please email support@academicmerit.com directly.", { timeout: 5 });
                /** Set HelpMenus state value popover.close to true, this will update the PopOver component close prop to true */
                this.props.closePopover(true);
            }
        );
    },
    submitRequestWithFiles(url, body, files) {
        for (let i = 0; i < files.length; i++) {
            body["file_upload_" + i] = files[i];
        }

        let postData = new FormData()

        for (let data in body) {
            postData.append(data, body[data])
        }

        this.setState({ loading: true })

        return api.postFile(url, {
            body: postData
        }).then(
            () => {
                this.setState({ loading: false })
                notify("Your message has been sent!", { timeout: 5 });
                this.clearDataFromSessionStorage(SESSION_STORAGE_CONTACT_US_KEY);
                /** Set HelpMenus state value popover.close to true, this will update the PopOver component close prop to true */
                this.props.closePopover(true);
            },
            () => {
                this.setState({ loading: false })
                notify.error("Error while sending mail, please email support@academicmerit.com directly.", { timeout: 5 });
                /** Set HelpMenus state value popover.close to true, this will update the PopOver component close prop to true */
                this.props.closePopover(true);
            }
        );
    },
    uploadFiles() {
        this.refs.fileUploadCtrl.getDOMNode().click();
    },
    renderUploadedFiles(files) {
        if (files.length < 1) return (<div className="Contact__row"><span>No file chosen</span></div>);

        let output = files.map((file, index) => {
            return (
                <div className="Contact__upload" key={index}>
                    <span>{file.name}</span>
                    <button onClick={() => this.removeFile(file)} className={cn('Contact__upload__remove', btn({ style: 'minimal' }))}>Remove</button>
                </div>
            )
        })

        return output;
    },
    removeFile(file) {
        let files = this.state.files.filter(e => e !== file);
        this.setState({ files });
        this.saveToSessionStorage(SESSION_STORAGE_CONTACT_US_KEY, Object.assign(this.state, { files }));
    },
    bytesToSize(bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },
    fileUploadChanged(e) {
        let files = this.state.files;
        let invalidFiles = [];
        let totalSize = files.reduce((cummulativeSize, file) => cummulativeSize + file.size, 0)

        for (let file of e.target.files) {
            let fileSize = file.size

            if ((fileSize + totalSize) <= MAX_BULK_FILE_SIZE) {

                if (fileSize <= MAX_INDIVIDUAL_FILE_SIZE) {
                    files.push(file);
                    totalSize += fileSize

                } else {
                    invalidFiles.push(file.name);
                }

            } else {
                notify.error(`Total maximum file upload size is ${this.bytesToSize(MAX_BULK_FILE_SIZE)}`, { timeout: 5 });
                break;
            }
        }

        if (invalidFiles.length > 0) {
            notify.error(`The following file(s) are too large: ${invalidFiles.join(', ')}`, { timeout: 5 });
            notify.error(`Files should not be larger than ${this.bytesToSize(MAX_INDIVIDUAL_FILE_SIZE)} each`, { timeout: 5 });
        }

        this.setState({ files });
        this.saveToSessionStorage(SESSION_STORAGE_CONTACT_US_KEY, this.state);
    },
    render() {
        const {
            issueType,
            issueDescriptionType,
            deviceType,
            deviceDetail,
            isInstitutionalDevice,
            files
        } = this.state;

        return (
            <div className="Contact">
                {this.state.successful ? (
                    <div>Thank you! Your inquiry has been sent to our Support team.</div>
                ) : (
                        <div>
                            <Columns className="Contact__column">
                                <span>Type of issue</span>
                                <select value={issueType} defaultValue=""
                                    onChange={this.setStateByKey} name="issueType">
                                    <option value="">Choose here</option>
                                    <option value="assistiveTechnology">Assistive Technology</option>
                                    <option value="loggingIn">Logging in</option>
                                    <option value="passwords">Passwords</option>
                                    <option value="assignment">Assignment</option>
                                    <option value="printing">Printing</option>
                                    <option value="results">Results</option>
                                    <option value="classes">Class Management</option>
                                    {this.shouldDisplayPLContactOption() && <option value="pl">Professional Learning</option>}
                                    <option value="issueDescription">Other</option>
                                </select>
                            </Columns>

                            {issueType === "issueDescription" ? (
                                <Columns className="Contact__column">
                                    <span>Issue description</span>
                                    <input className="Contact__input" type="text" value={issueDescriptionType}
                                        onChange={this.setStateByKey} name="issueDescriptionType" />
                                </Columns>
                            ) : null}

                            {this.requireMoreDetails() ? (
                                <div>
                                    <Columns className="Contact__column">
                                        <span>Type of device</span>
                                        <select value={deviceType || ""} onChange={this.setStateByKey} name="deviceType">
                                            <option value="">Choose here</option>
                                            <option value="desktop">Desktop computer</option>
                                            <option value="laptop">Laptop computer</option>
                                            <option value="tablet">Tablet</option>
                                            <option value="cellphone">Cell phone</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </Columns>

                                    <Columns className="Contact__column">
                                        <span>Device name/model/version</span>
                                        <input className="Contact__input" type="text" value={deviceDetail}
                                            onChange={this.setStateByKey} name="deviceDetail" />
                                    </Columns>

                                    <Columns className="Contact__column">
                                        <span>Is this a school/institutional device?</span>
                                        <select value={isInstitutionalDevice || ""}
                                            onChange={this.setStateByKey} name="isInstitutionalDevice"
                                        >
                                            <option value="">Choose here</option>
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                        </select>
                                    </Columns>
                                </div>
                            ) : null}

                            <div className="Contact__column">
                                <div>Subject</div>
                                <div>
                                    <input className="Contact__subject Contact__input" type="text" value={this.state.subject}
                                        onChange={this.setStateByKey} name="subject" />
                                </div>
                            </div>

                            {this.props.user.email ? null : (
                                <div className="Contact__column">
                                    <div>Email</div>
                                    <div>
                                        <input className="Contact__input" type="text" value={this.state.email}
                                            onChange={this.setStateByKey}
                                            name='email' />
                                    </div>
                                </div>
                            )}

                            <div className="Contact__column">
                                <span>Message</span>
                                <p className="help_text">Describe the experience you are currently having and, if possible, the experience you would expect. Include as much information as possible. This will help us resolve the issue.</p>
                                <div>
                                    <textarea className="Contact__message" value={this.state.message}
                                        onChange={this.setStateByKey} name="message" />
                                </div>
                            </div>

                            <div className="Contact__upload">
                                <input type="file" hidden multiple ref="fileUploadCtrl" onChange={this.fileUploadChanged} />
                                <span>Share Screenshot(s)</span>
                                <button onClick={this.uploadFiles} className={cn('', btn({ style: 'minimal' }))}>Choose File</button>
                            </div>

                            {this.renderUploadedFiles(files)}

                            {this.state.failed ? <div>{this.state.failed.toString()}</div> : null}

                            {this.state.loading ? (
                                <Loading message="Sending message" />
                            ) : (
                                    <Button btn={{ color: 'blue' }} className="Contact__button" disabled={this.isSendButtonDisabled() || this.state.isSendButtonDisabled}
                                        onClick={() => this.sendMessage()}>Send</Button>
                                )}
                        </div>
                    )}
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** core/client/rawr/controls/Contact.jsx
 **/